/*
 *  Product collection
 *
 *  Version:
 *    1.0.0 - 2019/16/13
 */

import $ from 'jquery';
import 'slick-carousel';

import { CarouselSection } from './../carousel/CarouselSection';
import { register } from './../ShopifySection';
import * as ResponsiveSizes from './../../settings/Responsive';

export const CONTAINER_SELECTOR = '[data-product-collection]';
export const CAROUSEL_SELECTOR = '[data-product-collection-carousel]';

export class ProductCollection extends CarouselSection {
  constructor(container) {
    super(container);

    this.container = container;
    this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    
    // carousel
    this.slick = this.initCarousel(this.carouselContainer);
    this.reSlick(ResponsiveSizes.small, this.carouselContainer);
  }

  optionOverrides() {
    return {
      infinite: this.carouselContainer.data('infinite') == false ? false : true,
      slidesToShow: this.carouselContainer.data('slides-to-show') || 2,
      slidesToScroll: this.carouselContainer.data('slides-to-scroll') || 1,
      autoplay: this.carouselContainer.data('autoplay') == false ? false : true,
      speed: this.carouselContainer.data('slide-speed') || 500,
      dots: this.carouselContainer.data('dots') == false ? false : true,
      arrows: this.carouselContainer.data('arrows') == false ? false : true,
      adaptiveHeight: this.carouselContainer.data('adaptiveheight') == false ? false : true,
      autoplaySpeed: this.carouselContainer.data('autoplay-speed') || 5000,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: ResponsiveSizes.xsmall-1,
          settings: { slidesToShow: 2, slidesToScroll: 2 }
        },
        {
          breakpoint: 659,
          settings: { slidesToShow: 3, slidesToScroll: 3 }
        },
        {
          breakpoint: ResponsiveSizes.small-1,
          settings: "unslick"
        }
      ]
    }
  }

}

register(CONTAINER_SELECTOR, ProductCollection);